/**
 * @generated SignedSource<<7f15176f1c2cedee05c84338d83af2b7>>
 * @relayHash fc0c99284f7172a2a928ac7f9e349528
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8103ffb22f44a5a625436a8a4bdb0a51a232726e403cb24dd496a427f96ef2b1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedSummaryQuery } from './decomposedSummaryQuery.graphql';

const node: PreloadableConcreteRequest<decomposedSummaryQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8103ffb22f44a5a625436a8a4bdb0a51a232726e403cb24dd496a427f96ef2b1",
    "metadata": {},
    "name": "decomposedSummaryQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
